import React, { useState, useEffect, useCallback } from "react";
import { Typography, Divider, CircularProgress } from '@material-ui/core';
import { makeStyles } from "@material-ui/styles";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import VerticalDetailsBox from "components/explore/common/VerticalDetailsBox";
import { shapeFields } from "components/explore/gmap/shapeFields";
import { getColorForShape, getShapeById } from "components/explore/gmap/helpers";
import SizeEditor from 'components/explore/views/objectEditors/SizeEditor';
import ColorEditor from 'components/explore/views/objectEditors/ColorEditor';
import { ColorPaletteDisplay, colorPalettePresets } from "components/explore/gmap/colorHelper";
import { getManualShapesGeoTypesForZoomLevel } from "api/rex/spatial";
import { connect } from "react-redux";
import { compose } from "recompose";
import { setExploreShapesColoringType, setExploreShapesRequestedGeoType, updateExploreShapesDataObjectById } from 'store/actions';
import { ButtonDropdown } from "components/layout";
import { formatValue } from "utilities/format";
import { sendClientLog } from 'services/logService';

const useStyles = makeStyles({
  root: {
    marginLeft: 10
  }, 
  // coloringTypeDropDown: {
  //   marginLeft: 10,
  //   marginTop: 0,
  //   fontSize: 12,
  //   padding: 0,
  //   margin: 0,
  //   // maxWidth: 150
  // },
  // coloringTypeDropDownItem: {
  //   fontSize: 12,
  //   paddingLeft: 10,
  //   paddingRight: 10,
  //   paddingTop: 0,
  //   paddingBottom: 0
  // },
  coloringLegendItemText: {
    marginLeft: 5,
    marginRight: 5,
    marginTop: 3,
    marginBottom: 3,
    color: '#ffffff',
    zIndex: 1
  },
  // select: {
  //  paddingTop: 9 
  // },
  sectionContainer: {
    padding: '8px 24px 16px'
  },
  sectionTitle: {
    marginLeft: -8,
    marginBottom: 4,
    fontSize: '1rem'
  },
  paletteLabelContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 8
  }
});

function MarketsDetail({ object, mapReady, shapesData, coloringType, requestedGeoType, dataGeoType,
  setExploreShapesColoringType, setExploreShapesRequestedGeoType, zoom, customPalette, fillOpacity, strokeWeight,
  updateExploreShapesDataObjectById, selectedShapeId, isLoading }) {
  const classes = useStyles();
  const [selectedColoringType, setSelectedColoringType] = useState(coloringType);
  const [colorMatrix, setColorMatrix] = useState({});
  
  useEffect(() => {
    if (!selectedColoringType) return;
    updateColorMatrix(coloringType);
  },[shapesData, customPalette]);

  function onColoringTypeChange(event, value) {
    setSelectedColoringType(value.props.value);
    setExploreShapesColoringType(object.id, value.props.value);
    updateColorMatrix(value.props.value);
  }

  function onRequestedGeoTypeChange(event, value) {
    setExploreShapesRequestedGeoType(object.id, value.props.value === 'none' ? null : value.props.value);
  }

  function updateColorMatrix(coloringType) {
    const fieldDataType = shapeFields.find(f => f.dataField === coloringType)?.dataType;
    const shapeWithValue = shapesData.find(shape => shape[coloringType] != null); // Find a nonnull value to use to guarantee that getColorForShape returns value colors
    const colorMatrix = getColorForShape(customPalette, shapeWithValue, shapesData, coloringType, fieldDataType); //ok to pass any single shape as placeholder
    colorMatrix.minValueDisplay = formatColorMatrixValue(colorMatrix.minValue, coloringType);
    colorMatrix.midValueDisplay = formatColorMatrixValue(colorMatrix.midValue, coloringType);
    colorMatrix.maxValueDisplay = formatColorMatrixValue(colorMatrix.maxValue, coloringType);
    setColorMatrix(colorMatrix);
  }

  function formatColorMatrixValue(value, coloringType) {
    var fieldSettings = shapeFields.find(f => f.dataField === coloringType);
    if (value && fieldSettings && fieldSettings.format) {
      return formatValue(value, fieldSettings.format, false, "-n/a-");
    }
    return "-n/a-";
  }

  function getField() {
    console.log(selectedColoringType)
    console.log(shapeFields)
    return shapeFields.find(f => f.dataField === selectedColoringType);
  }

  const getGeoTypes = useCallback(() => {
    return getManualShapesGeoTypesForZoomLevel(zoom);
  }, [zoom]);

  const selectedShape = getShapeById(shapesData, selectedShapeId);

  const onPalettePresetChange = e => {
    updateExploreShapesDataObjectById(object.id, { customPalette: e.value });
    sendClientLog('Info',`Explore Views - User set palette to preset ${e.value.id} for object id ${object.id}, layer id ${object.layerId}`);
  }

  const handlePaletteColorChange = (value, position) => {
    const newPalette = { ...customPalette, [position]: value };
    updateExploreShapesDataObjectById(object.id, { customPalette: newPalette });
  }

  const handleStrokeWeightChange = value => {
    updateExploreShapesDataObjectById(object.id, { strokeWeight: value });
  }

  const handleFillOpacityChange = value => {
    updateExploreShapesDataObjectById(object.id, { fillOpacity: value });
  }

  if (!mapReady) return null;
  return (     
    <>
      <div className={classes.sectionContainer}>
        <div style={{ display: 'flex' }}>
          <Typography variant='subtitle2' color='inherit' className={classes.sectionTitle} style={{ marginRight: 8 }}>{'Geo Type'}</Typography>
          {isLoading &&
            <CircularProgress size={24} />
          }
        </div>
        <Select
          disableUnderline
          value={requestedGeoType ?? 'none'}
          onChange={onRequestedGeoTypeChange}
          displayEmpty
          name="geoType"
          className={classes.coloringTypeDropDown}
          classes={{
            select: classes.select
          }}
          >
          {/* <MenuItem className={classes.coloringTypeDropDownItem} value='none' variant="caption">
            None
          </MenuItem> */}
          <MenuItem className={classes.coloringTypeDropDownItem} value="auto" variant="caption">
            {requestedGeoType === 'auto' && dataGeoType ? `Auto - ${dataGeoType}` : 'Auto'}
          </MenuItem>
          {
            getGeoTypes().map(type => {
              return <MenuItem  key={type.value} 
                                variant="caption"
                                className={classes.coloringTypeDropDownItem} 
                                value={type.value}
                                disabled={!type.enabled}>
                            {type.caption}
                    </MenuItem>
            })
          }
        </Select>
      </div>
      <Divider />
      <div className={classes.sectionContainer}>
        <Typography variant='subtitle2' color='inherit' className={classes.sectionTitle}>{'Coloring Field'}</Typography>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Select
            disableUnderline
            value={selectedColoringType}
            onChange={onColoringTypeChange}
            displayEmpty
            name="shapeColoring"
            className={classes.coloringTypeDropDown}
            >
              <MenuItem variant="caption" className={classes.coloringTypeDropDownItem} value={''} >
                None
              </MenuItem>
            {
              shapeFields.map(field => {
                return <MenuItem  key={field.dataField} 
                                  variant="caption"
                                  className={classes.coloringTypeDropDownItem} 
                                  value={field.dataField}>
                              {field.caption}
                      </MenuItem>
              })
            }
          </Select>
          {
            dataGeoType && selectedColoringType && selectedColoringType !== "" && getField()?.dataType === 'number' &&
            <div style={{
                              marginLeft: 10,
                              borderRadius: 3,                                        
                              minWidth: 130, 
                              display: 'flex', 
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              overflow: 'hidden',
                              position: 'relative',
                              width: '50%',
                              height: 25
                      }}>
              <div style={{ position: 'absolute', width: '50%', height: '100%', background: `linear-gradient(to right, ${colorMatrix.minValueColor ?? colorMatrix.valueColor}, ${colorMatrix.midValueColor ?? colorMatrix.valueColor})` }}></div>
              <div style={{ position: 'absolute', width: '50%', height: '100%', background: `linear-gradient(to right, ${colorMatrix.midValueColor ?? colorMatrix.valueColor}, ${colorMatrix.maxValueColor ?? colorMatrix.valueColor})`, right: 0 }}></div>
              <Typography variant="caption" className={classes.coloringLegendItemText}>{colorMatrix.minValueDisplay}</Typography>
              <Typography variant="caption" className={classes.coloringLegendItemText}>{colorMatrix.midValueDisplay}</Typography>
              <Typography variant="caption" className={classes.coloringLegendItemText}>{colorMatrix.maxValueDisplay}</Typography>
            </div>
          }
        </div>
      </div>
      <Divider />
      <div className={classes.sectionContainer}>
        <Typography variant='subtitle2' color='inherit' className={classes.sectionTitle}>{'Coloring Palette'}</Typography>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            <ColorPaletteDisplay palette={customPalette} fullWidth height={24} />
            <div className={classes.paletteLabelContainer}>
              <Typography variant='subtitle2' style={{ marginRight: 8 }}>Min:</Typography>
              <ColorEditor value={customPalette?.c0} onChange={(val) => handlePaletteColorChange(val, 'c0')} />
            </div>
            <div className={classes.paletteLabelContainer}>
              <Typography variant='subtitle2' style={{ marginRight: 8 }}>Mid:</Typography>
              <ColorEditor value={customPalette?.c1} onChange={(val) => handlePaletteColorChange(val, 'c1')} />
            </div>
            <div className={classes.paletteLabelContainer}>
              <Typography variant='subtitle2' style={{ marginRight: 8 }}>Max:</Typography>
              <ColorEditor value={customPalette?.c2} onChange={(val) => handlePaletteColorChange(val, 'c2')} />
            </div>
          </div>
          <div>
            <ButtonDropdown
              title='Presets'
              onSelect={onPalettePresetChange}
              style={{ margin: 0 }}
              items={colorPalettePresets.map(palette => {
                return {
                  id: palette.id,
                  text: <ColorPaletteDisplay palette={palette} />,
                  value: palette
                }
              })}
            />
            <div></div>
          </div>
        </div>
      </div>
      <Divider />
      <div className={ classes.sectionContainer }>
        <Typography variant='subtitle2' color='inherit' className={ classes.editorTitle }>{'Border Width'}</Typography>
        <SizeEditor value={ strokeWeight ?? 1} onChange={ handleStrokeWeightChange } min={0} max={3} />
      </div>
      <Divider />
      <div className={ classes.sectionContainer }>
        <Typography variant='subtitle2' color='inherit' className={ classes.editorTitle }>{'Fill Opacity'}</Typography>
        <SizeEditor value={ fillOpacity ?? 0.7 } onChange={ handleFillOpacityChange } min={0} max={1} />
      </div>
      <Divider />
      {selectedShapeId && selectedShapeId !== '' && selectedShape &&
        <>
          <div className={classes.sectionContainer}>
            <Typography variant='subtitle2' color='inherit' className={classes.sectionTitle}>{'Selected Market Info'}</Typography>
            <VerticalDetailsBox 
              contentPadding={10}
              dataItem={selectedShape}
              fields={shapeFields}
              title={selectedShape.GeoName}
            />
          </div>
          <Divider />
        </>
      }
    </>
  )
}

function mapState({ exploreShapesData, exploreMap }, ownProps) {    
  const shapesDataObject = exploreShapesData.shapesDataObjects[ownProps.object.id];
  return {   
    shapesData: shapesDataObject.shapesData,       
    coloringType: shapesDataObject.coloringType,
    requestedGeoType: shapesDataObject.requestedGeoType,
    dataGeoType: shapesDataObject.dataGeoType,
    mapReady: exploreMap.bounds !== null && exploreMap.bounds !== undefined,
    zoom: exploreMap.zoom,
    customPalette: shapesDataObject.customPalette,
    fillOpacity: shapesDataObject.fillOpacity,
    strokeWeight: shapesDataObject.strokeWeight,
    selectedShapeId: shapesDataObject.selectedShapeId,
    isLoading: shapesDataObject.isLoading
  };
}

const mapDispatch = {
  setExploreShapesColoringType,
  setExploreShapesRequestedGeoType,
  updateExploreShapesDataObjectById
}

export default compose(
  connect(mapState, mapDispatch)
)(MarketsDetail);